import React, { useState } from 'react';

const FAQSection = ({ title, subtitle, items = [] }) => {
    const [openIndex, setOpenIndex] = useState(0);

    const toggle = (index) => {
        setOpenIndex(openIndex === index ? -1 : index);
    };

    return (
        <div className="mxd-section padding-pre-grid my-4 my-md-5 py-3 py-md-4">
            <div className="mxd-container grid-container">
                <div className="mxd-block">
                    <div className="mxd-section-title">
                        <div className="container-fluid p-0">
                            <div className="row g-0">
                                <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                    <div className="mxd-section-title__hrtitle">
                                        <h2 className="reveal-type">{title}</h2>
                                    </div>
                                </div>
                                <div className="col-12 col-xl-6 mxd-grid-item no-margin">
                                    <div className="mxd-section-title__hrdescr">
                                        <p className="anim-uni-in-up">{subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mxd-accordion loading__fade">
                        {items.map((item, index) => (
                            <div key={index} className="mxd-accordion__item">
                                <div className="mxd-accordion__divider anim-uni-in-up"></div>
                                <div
                                    className="mxd-accordion__title anim-uni-in-up"
                                    role="button"
                                    tabIndex={0}
                                    aria-expanded={openIndex === index}
                                    onClick={() => toggle(index)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            toggle(index);
                                        }
                                    }}
                                >
                                    <h6>{item.q}</h6>
                                    <div className={`mxd-accordion__arrow${openIndex === index ? ' accordion-rotate' : ''}`}>
                                        <i className="ph ph-plus"></i>
                                    </div>
                                </div>
                                <div
                                    className="mxd-accordion__content"
                                    style={{ display: openIndex === index ? 'flex' : 'none' }}
                                >
                                    <p className="mxd-accordion__text">{item.a}</p>
                                </div>
                                <div className="mxd-accordion__divider anim-uni-in-up"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQSection;
